import { useTranslation } from 'react-i18next'
import ResearcherShell from '@/components/researcher/ResearcherShell'
import LiveEmotionDemo from '@/components/researcher/liveDemo/LiveEmotionDemo'

/**
 * Emotion-analysis demo: live webcam only. The model runs in the browser
 * (src/lib/emotion, same Haar + CNN as the backend) — no frame reaches the
 * server, same engine as the landing hero.
 */
export default function EmotionDemo() {
  const { t } = useTranslation('liveDemo')
  return (
    <ResearcherShell active="live" crumbs={[t('title')]} hideTopBarAction>
      <LiveEmotionDemo />
    </ResearcherShell>
  )
}
